import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import careersActions from "../store/actions/careers";
import JobItem from "../components/Careers/JobItem";
import Slider from "react-slick";
import ModalApplyNow from "../components/Careers/ModalApplyNow";
import {Link} from 'react-router-dom'
import ModalBecomeAgent from "../components/Careers/ModalBecomeAgent";
import { Link as ScrollLink} from "react-scroll";




const Careers = () => {
    const careersStore = useSelector((store) => store.careersStore);
    const dispatch = useDispatch();

    const [windowWidth, setWindowWidth] = useState(0);

    let resizeWindow = () => {
        setWindowWidth(window.innerWidth);
    };

    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    const agentModalOpen = () => {
        dispatch(careersActions.setModalAgentOpen(true));
        document.getElementsByTagName('body')[0].classList.add('modal-open');
    }

    const modalSuccessClose = () => {
        dispatch(careersActions.setModalSuccessOpen(false));
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
    }

    useEffect(() => {
        dispatch(careersActions.fetchJobs());

        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);


    const jobsList = careersStore.jobList.map((job, index) => {
        return <JobItem
            key = {job.id}
            job = {job}
            number = {index}
        />;
    });

    const utpItem1 = () => {
        return (
            <div className="careers-utp__item-wrapper">
                <div className="careers-utp__item">
                    <div className="careers-utp__item-heading">
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/utp/icon1.svg`} alt="icon"/>
                        <div className="careers-utp__item-title">We reward our people</div>
                    </div>
                    <div className="careers-utp__item-content">
                        All full-time RVOS Insurance employees are offered a compensation program that recognizes their skills, ability, and performance. We offer a competitive salary and great benefits.
                    </div>
                </div>
            </div>
        )
    }
    const utpItem2 = () => {
        return (
            <div className="careers-utp__item-wrapper">
                <div className="careers-utp__item">
                    <div className="careers-utp__item-heading">
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/utp/icon2.svg`} alt="icon"/>
                        <div className="careers-utp__item-title">We love to learn</div>
                    </div>
                    <div className="careers-utp__item-content">
                        We grow future leaders within the company at every opportunity. We support employee growth by offering a wide range of continuing education opportunities, certification programs, and management training.
                    </div>
                </div>
            </div>
        )
    }
    const utpItem3 = () => {
        return (
            <div className="careers-utp__item-wrapper">
                <div className="careers-utp__item">
                    <div className="careers-utp__item-heading">
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/utp/icon3.svg`} alt="icon"/>
                        <div className="careers-utp__item-title">We prioritize employee well-being</div>
                    </div>
                    <div className="careers-utp__item-content">
                        We offer comprehensive healthcare coverage, including medical, dental, vision and a generous 401(k) plan. We support work-life balance through flexible work schedules, mental health coverage, and wellness incentives.
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="careers">
            {careersStore.modalOpen &&
                <ModalApplyNow/>
            }
            {careersStore.modalAgentOpen &&
                <ModalBecomeAgent/>
            }
            <div className="careers-wrapper">
                <div className="careers-main">
                    <div className="careers-main__content">
                        <div className="careers-main__block-decor left">
                            <div className="left-group1">
                                <img className="blob1" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/blob1.svg`} alt="blob"/>
                                <img className="blob2" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/blob2.svg`} alt="blob"/>
                            </div>
                            <div className="left-group2">
                                <img className="decor-user" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/decor-user.svg`} alt="decor"/>
                                <img className="decor-arrow" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/decor-arrow.svg`} alt="decor"/>
                            </div>
                            <img className="person1" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/person1.png`} alt="person"/>
                            <img className="person2" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/person2.png`} alt="person"/>
                        </div>
                        <div className="careers-main__block-decor right">
                            <div className="right-group1">
                                <img className="blob3" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/blob3.svg`} alt="blob"/>
                                <img className="blob4" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/blob4.svg`} alt="blob"/>
                            </div>
                            <img className="person3" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/person3.png`} alt="person"/>
                            <img className="person4" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/person4.png`} alt="person"/>
                            <img className="person5" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/main/person5.png`} alt="person"/>
                        </div>
                        <div className="careers-main__title">Join our team</div>
                        <div className="careers-main__subtitle">If you're looking to make a difference - we're looking for you</div>
                        <div className="careers-btn-row">
                            <ScrollLink
                                to="careers-banner"
                                className="careers-btn button-blue"
                                smooth={true}
                                offset={-70}
                                duration={500}
                            >
                                Find Jobs
                            </ScrollLink>
                            <button type="button" className="careers-btn button-blue" onClick={() => {agentModalOpen()}}>Become an Agent</button>
                        </div>
                    </div>
                </div>
                <div className="careers-utp">
                    <div className="container">
                        {windowWidth < 1024 ? (
                            <div className="careers-utp__list-slider">
                                <Slider {...settings}>
                                    {utpItem1()}
                                    {utpItem2()}
                                    {utpItem3()}
                                </Slider>
                            </div>
                        ) : (
                            <div className="careers-utp__list">
                                {utpItem1()}
                                {utpItem2()}
                                {utpItem3()}
                            </div>
                        )}
                    </div>
                </div>
                <div className="careers-banner" id="careers-banner">
                    <div className="container">
                        <div className="careers-banner__content">
                            <div className="careers-banner__title">Current job openings</div>
                            <div className="careers-banner__blob left">
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/banner/blob1.svg`} alt="blob"/>
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/banner/blob2.svg`} alt="blob"/>
                            </div>
                            <div className="careers-banner__blob right">
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/banner/blob3.svg`} alt="blob"/>
                                <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/banner/blob4.svg`} alt="blob"/>
                            </div>
                            <div className="careers-banner__man-wrapper">
                                <img className="careers-banner__man" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/banner/man.svg`} alt="man"/>
                            </div>
                            <img className="careers-banner__woman" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/careers/banner/woman.svg`} alt="woman"/>
                        </div>
                    </div>
                </div>
                <div className={`careers-jobs ${careersStore.isLoading ? 'is-loading' : ''}`}>
                    <div className="careers-spinner"/>
                    <div className="container">
                        {jobsList.length > 0 ? (
                            <div className="careers-jobs__list">
                                {jobsList}
                            </div>
                        ) : (
                            <div className="careers-jobs__empty">
                                There are no open positions <span className="nowrap">at this time</span>
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <div className={`modal modal-success ${careersStore.modalSuccessOpen ? 'open' : ''}`}>
                <div className="modal-overlay" onClick={() => modalSuccessClose()}/>
                <div className="modal-block">
                    <button type="button" className="modal-close" onClick={() => modalSuccessClose()}>
                        <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/find-an-agent/close.svg`}/>
                    </button>
                    <div className="modal-success-container">
                        <img className="modal-success-image" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/contact-us/icon-success.svg`}/>
                        <div className="modal-success-title">Thank You!</div>
                        <div className="modal-success-text">Your request was successfully sent</div>
                        <button className="modal-success-btn button-gradient" onClick={() => modalSuccessClose()}>Back to Job Openings</button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Careers;

